import {
  CLEAN_TENDER,
  SAVE_INITIATED,
  SET_TENDER,
  SET_TENDER_LIST,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  TENDER_SET_SAVED,
} from './actionTypes';
import {
  IFailedSyncAction,
  ISetTenderAction,
  ISetTendersAction,
  ITendersAction,
  ITendersState,
  IUpdateTenderAction,
} from './types';

export const initialState = {
  error: null,
  loaded: false,
  syncing: 0,
  tender: null,
  tenders: [],
  updateErrors: [],
  tenderSaved: false,
};

export const reducer = (
  state: ITendersState = initialState,
  action: ITendersAction
): ITendersState => {
  switch (action.type) {
    case SYNC_INITIATED:
      return { ...state, error: null, syncing: state.syncing + 1, tenderSaved: false };
    case SAVE_INITIATED:
      return {
        ...state,
        error: null,
        updateErrors: [],
        syncing: state.syncing + 1,
        tenderSaved: false,
      };
    case SYNC_FINISHED:
      return { ...state, syncing: state.syncing - 1 };
    case SET_TENDER_LIST:
      return {
        ...state,
        tenders: (action as ISetTendersAction).payload,
        loaded: true,
      };
    case SET_TENDER:
      return {
        ...state,
        tender: (action as ISetTenderAction).payload,
        updateErrors: [],
      };
    case TENDER_SET_SAVED:
      return {
        ...state,
        updateErrors: (action as IUpdateTenderAction).payload.failedRuleIds || [],
        tender: (action as IUpdateTenderAction).payload.tender,
        tenderSaved: true,
        loaded: false,
      };
    case CLEAN_TENDER:
      return {
        ...state,
        tender: null,
      };
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload };
    default:
      return state;
  }
};
